import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { StyledPageHeader } from "../../styles/StyledPage";
import ProfileIcon from "../../assets/img/icons/profile.svg";
import styled, { ThemeProvider } from "styled-components";
import { theme } from "../../styles/theme";

const UnderConstructionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  text-align: center;
  padding: 2rem;
`;

const ConstructionIcon = styled.div`
  font-size: 6rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.color.black};
`;

const ConstructionTitle = styled.h2`
  color: ${({ theme }) => theme.color.black};
  margin-bottom: 1rem;
  font-size: 2.4rem;
`;

const ConstructionText = styled.p`
  color: ${({ theme }) => theme.color.gray};
  font-size: 1.6rem;
  max-width: 50rem;
  line-height: 1.5;
`;

export default function PeoplePage() {
  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Row style={{ marginTop: "2rem" }}>
          <Col sm={12} lg={2}>
            <Sidemenu />
          </Col>
          <Col sm={12} lg={10}>
            <StyledPageHeader>
              <div>
                <i>
                  <img src={ProfileIcon} alt="People" />
                </i>
                <span>People</span>
              </div>
            </StyledPageHeader>

            <UnderConstructionContainer>
              <ConstructionIcon>🚧</ConstructionIcon>
              <ConstructionTitle>Under Construction</ConstructionTitle>
              <ConstructionText>
                This page is currently being developed. Check back in later!
              </ConstructionText>
            </UnderConstructionContainer>
          </Col>
        </Row>
      </Container>
    </ThemeProvider>
  );
}
